<script lang="ts">
	import { env } from '$env/dynamic/public';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import * as m from '$paraglide/messages';

	const { PUBLIC_SALESFORCE_ISSUER } = env;

	let loading = $state(true);
</script>

<div class="grid place-items-center h-full">
	<div class="flex flex-col gap-2">
		<div class="p-2">{loading ? m.sf_logout__loading() : m.sf_logout__logged_out()}</div>
		<Button
			variant="outline"
			onclick={() => window.close()}
			icon="close"
			text={m.sf_logout__close_button()}
		/>
	</div>
</div>

<iframe
	title="michelin-sf-logout"
	id="michelin-sf-logout"
	src={`${PUBLIC_SALESFORCE_ISSUER}/services/auth/idp/oidc/logout`}
	width="0"
	height="0"
	aria-hidden="true"
	tabindex="-1"
	onload={() => {
		loading = false;
		window.close();
	}}
></iframe>
